<template>
    <CRow>
        <CCol col="4" class="pr-0">
            <CSelect
                :placeholder="$t('code')"
                :options="select"
                :value.sync="code"
                :isValid="isValid"
                :disabled="disabled"
            />
        </CCol>
        <CCol col="8">
            <CInput
                :placeholder="`${$t('phone')}`"
                autocomplete="phone"
                type="tel"
                :value.sync="phone"
                :isValid="isValid"
                :disabled="disabled"
            ></CInput>
        </CCol>
    </CRow>
</template>

<script>
import countries from "@sset/countries.json";

export default {
    name: "PhoneNumberInput",

    created() {
        for (let i = 0; i < countries.length; i++) {
            const country = countries[i];
            this.select.push({ value: i, label: country.name });
        }
    },

    props: {
        isValid: {
            type: Boolean,
            default: null,
        },
        disabled: {
            default: false,
        },
        value: {
            default: null,
        }

    },

    data: () => ({
        select: [],
        code: "",
        phone: ""
    }),

    watch: {
        code(newValue, oldValue) {
            if (this.phone == "")
                this.phone = "+" + countries[newValue].callingCodes[0];
            else {
                if (oldValue) {
                    let callingCode =
                        countries[oldValue].callingCodes[0].toString();
                    let current_code = this.phone.slice(
                        0,
                        callingCode.length + 1
                    );
                    if (
                        current_code ==
                        "+" + countries[oldValue].callingCodes[0]
                    ) {
                        this.phone = this.phone.replace(
                            `+${countries[oldValue].callingCodes[0]}`,
                            `+${countries[newValue].callingCodes[0]}`
                        );
                    } else {
                        this.phone = this.phone.replace(
                            `${current_code}`,
                            `+${countries[newValue].callingCodes[0]}`
                        );
                    }
                } else {
                    this.phone =
                        "+" + countries[newValue].callingCodes[0] + this.phone;
                }
            }
        },
        phone(oldValue, newValue) {
            if (this.code) {
                let callingCode =
                    countries[this.code].callingCodes[0].toString();
                let current_code = this.phone.slice(0, callingCode.length + 1);
                if ("+" + callingCode != current_code) {
                    this.phone =
                        "+" +
                        countries[this.code].callingCodes[0] +
                        this.phone;
                }
            }
            if(oldValue !== newValue)
                this.$emit('update:value',this.phone);
        },

        value(){
            this.phone = this.value;
        }
    },
    mounted(){
        if(this.value){
            this.phone = this.value;
        }
    }
    
};
</script>
